<div id="welcome-intro" fxFlex fxHide fxShow.gt-xs>
  <div class="logo" [@animate]="{ value: '*', params: { scale: '0.2' } }">
    <img src="assets/images/logos/logo.png" />
  </div>
  <div
    class="title"
    [@animate]="{ value: '*', params: { delay: '50ms', y: '25px' } }"
  >
    BIENVENIDO A NUBYY!
  </div>
  <div
    class="description"
    [@animate]="{ value: '*', params: { delay: '100ms', y: '25px' } }"
  >
    Nubyy es un software intuitivo con funciones totalmente integradas, las
    cuales facilitan la comunicacion de forma rapida y segura con tu red de
    contactos, permitiendo gestionar, administrar y delegar de forma practica
    tus actividades personales como empresariales.
  </div>
  <div fxLayout="row" class="imagenes-personas" fxLayoutAlign="center">
    <img src="./assets/images/personas/1" width="80" height="80" />
    <img src="./assets/images/personas/2" width="80" height="80" />
    <img src="./assets/images/personas/3" width="80" height="80" />
    <img src="./assets/images/personas/4" width="80" height="80" />
    <img src="./assets/images/personas/5" width="80" height="80" />
    <img src="./assets/images/personas/6" width="80" height="80" />
    <img src="./assets/images/personas/7" width="80" height="80" />
    <img src="./assets/images/personas/8" width="80" height="80" />
  </div>
  <div fxLayout="row" fxLayoutAlign="center">
    <img src="./assets/images/personas/9" width="80" height="80" />
    <img src="./assets/images/personas/10" width="80" height="80" />
    <img src="./assets/images/personas/11" width="80" height="80" />
    <img src="./assets/images/personas/12" width="80" height="80" />
    <img src="./assets/images/personas/13" width="80" height="80" />
    <img src="./assets/images/personas/14" width="80" height="80" />
    <img src="./assets/images/personas/15" width="80" height="80" />
    <img src="./assets/images/personas/16" width="80" height="80" />
  </div>
  <div class="cada-dia">
    <span>Cada dia se registran mas y mas usuarios</span>
  </div>
</div>
